// Re-export schemas and types from centralized location
export {
  tagSchema,
  assistantSchema,
  conversationSchema,
  conversationQuestionsItemSchema,
  userPreferencesSchema,
  viewportSchema,
  type Tag,
  type Assistant,
  type Conversation,
  type ConversationQuestionsItem,
  type UserPreferences,
  conversationContentRowSchema,
  type ConversationContentRow,
} from "@/types/schemas";

// DocumentType schema (specific to DB, not in core schemas)
// This is a simplified version without branded types for DB operations
import { z } from "zod";
export const documentTypeSchema = z.object({
  id: z.string(),
  label: z.string(),
  color: z.string(),
});
export type DocumentType = z.infer<typeof documentTypeSchema>;
